import React, { useState } from 'react';
import { 
  Button, 
  Dialog, 
  DialogContent, 
  Box,
  IconButton
} from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Image Preview - Material UI version
 *
 * @export
 * @param {{ imageSource: string, className?: string }} props
 * @return {*} 
 */
export const ImagePreview: React.FC<{ imageSource: string, className?: string }> = (props) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button 
        className={props.className} 
        startIcon={<ZoomInIcon />}
        onClick={handleOpen}
        variant="outlined"
        size="small"
      >
        Preview
      </Button>
      
      <Dialog 
        open={open} 
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogContent sx={{ position: 'relative', p: 2 }}>
          <IconButton
            sx={{ position: 'absolute', right: 8, top: 8 }}
            onClick={handleClose}
            size="small"
          >
            <CloseIcon />
          </IconButton>
          <Box 
            display="flex" 
            flexDirection="column" 
            alignItems="center" 
            width="100%"
          >
            <Box
              component="img"
              sx={{ 
                width: '100%', 
                objectFit: 'contain',
                maxHeight: '80vh'
              }} 
              src={props.imageSource} 
              alt="preview" 
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ImagePreview; 